export default "__VITE_ASSET__DatZQQ8z__"